import React from 'react'

import "./models.css"
import { useNavigate } from 'react-router-dom';
export default function Model() {

  const navigate = useNavigate()
  return (
    <div className='emas__models'>
      <h1>Electricity Market Models and Simulations</h1>
      <div className='emas__models-container'>
        <div className='emas__models-container_text'>
          <p> Our wholesale market models can be used to provide short-term and long-term views of the wholesale electricity market. They are based on detailed bottom-up models of underlying demand, rooftop solar output, battery and EV output. Thermal generation offers are cost-based. Windfarms replace coal generation as required. Big batteries enter the market to provide essential services and pricing arbitrage.  </p>
          <button onClick={ () => navigate('/Contact-Us')}>Contact Us</button>
        </div>
        <div className='emas__models-container_box'>
          <h2>Our approach to modelling</h2>
          <p> A model is only as good as the underlying assumptions. We spend a lot of time reviewing assumptions and making sure they are robust. We have developed our models by testing the results with alternative modelling methods. In the long term we consider market outcomes will be driven by the economics of demand and technology, and that the market rules will adapt to ensure demand is met in the most efficient way.</p>
        </div>
      </div>
    </div>
  )
}
